// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"6a69f3f6","453":"fbaf8072","934":"5146ae9c"}[chunkId] + ".chunk.js";
};